import { render, staticRenderFns } from "./CMenuItem.vue?vue&type=template&id=3c52baf4&"
import script from "./CMenuItem.vue?vue&type=script&lang=ts&"
export * from "./CMenuItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports